const userManagementEn = {
    companyPermission: require('../../lang/en/user_management/CompanyPermission').default,
};

export default userManagementEn;